import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LandingGuard } from '@app/landing/landing.guard.service';
import { AuthGuard } from '@shared/guards/auth.guard';
import { FeatureGuard } from '@shared/guards/feature.guard';
import { NavigateGuard } from '@shared/guards/navigate.guard';
import { CustomRoute } from '@app/custom-route.types';

const routes: CustomRoute[] = [
  {
    path: '',
    loadChildren: async () => (await import('app/landing/landing.module')).LandingModule,
    canActivate: [AuthGuard, LandingGuard]
  },
  {
    path: 'telephony/did',
    loadChildren: async () => (await import('app/telephony/did/did.module')).DIDModule,
    canActivate: [AuthGuard],
    canActivateChild: [NavigateGuard]
  },
  {
    path: 'teams',
    loadChildren: async () => (await import('app/teams/teams.module')).TeamsModule,
    canActivate: [AuthGuard, FeatureGuard],
    canActivateChild: [NavigateGuard],
    data: {
      activationFeatures: ['groups.enable-teams']
    }
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

/** Base routing module bootstrapping */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: true
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
